const hasScrolled = (lastScrollTop) => {
  const delta = 5;
  const navbarHeight = $('#secondary-menu').outerHeight();
  var st = $(document).scrollTop();
  if (Math.abs(lastScrollTop - st) <= delta) return;
  // If current position > last position AND scrolled past navbar...
  if (st > lastScrollTop && st > navbarHeight) {
    // Scroll Down
    $('#secondary-menu').addClass('mt-[-71px]');
  } else {
    // Scroll Up
    // If did not scroll past the document (possible on mac)...
    if (st + $(window).height() < $(document).height()) {
      $('#secondary-menu').removeClass('mt-[-71px]');
    }
  }
  return st;
};
const showMenuOnScrollUp = () => {
  if (window.matchMedia('(max-width: 1023px)').matches) return;
  let didScroll;
  let lastScrollTop = 0;
  $(window).scroll(function () {
    didScroll = true;
  });
  setInterval(function () {
    if (didScroll) {
      lastScrollTop = hasScrolled(lastScrollTop);
      didScroll = false;
    }
  }, 250);
};

export default showMenuOnScrollUp;